import React, { useCallback } from 'react';
import { MenuItem } from '../types';

export const useMenuItem = () => {
    const hasActiveChild = useCallback((items: MenuItem[], targetPath: string): boolean => {
        return items.some(item => 
            item.path === targetPath ||
            item.activePaths?.includes(targetPath) ||
            (item.subMenu?.length && hasActiveChild(item.subMenu, targetPath))
        );
    }, []);

    const getItemKey = useCallback((item: MenuItem, parentKey?: string): string => {
        return parentKey ? `${parentKey}.${item.id || item.label}` : (item.id || item.label);
    }, []);

    const handleClick = useCallback((
        e: React.MouseEvent, 
        item: MenuItem, 
        hasChildren: boolean, 
        isCollapsed: boolean, 
        level: number, 
        onToggleExpand: (itemKey: string, level?: number) => void, 
        itemKey: string, 
        onItemClick?: (item: MenuItem) => void
    ) => {
        if ((isCollapsed && level === 0 && hasChildren) || (hasChildren && !isCollapsed)) {
            e.preventDefault();
            e.stopPropagation();
            if (!isCollapsed || level > 0) onToggleExpand(itemKey, level);
            return;
        }

        if (item.path && !hasChildren && onItemClick) {
            onItemClick(item);
        }
    }, []);

    return { hasActiveChild, getItemKey, handleClick };
};
